import { render, staticRenderFns } from "./NoteHistoryDialog.vue?vue&type=template&id=00cace24"
import script from "./NoteHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./NoteHistoryDialog.vue?vue&type=script&lang=ts"
import style0 from "./NoteHistoryDialog.vue?vue&type=style&index=0&id=00cace24&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports